import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import DropzoneS3Uploader from 'react-dropzone-s3-uploader';
import { Button, ProgressBar } from 'react-bootstrap';
import S3DownloadButton from './s3-download-button';
import _ from 'lodash';
import config from 'react-global-configuration';
import PropTypes from 'prop-types';
import S3Upload from 'react-s3-uploader/s3upload';

class UploadDisplay extends React.Component {
    constructor(props) {
        super(props);
    }

    renderFileUpload = (uploadedFile, i) => {
        const { file, publicUrl } = uploadedFile;
        return (
            <div key={i} onClick={e => e.stopPropagation()} className={'col-xs-6'}>
                <S3DownloadButton bsStyle="link" publicUrl={publicUrl}>
                    {file.name}
                </S3DownloadButton>
                {
                    <Button
                        bsSize="xsmall"
                        onClick={() => {
                            this.props.handleRemove(publicUrl);
                        }}
                    >
                        x
                    </Button>
                }
            </div>
        );
    };

    render() {
        let { uploadedFiles, s3Url } = this.props;
        const isInProgress = this.props.progress != undefined;
        const progressIsZero = isInProgress && this.props.progress === 0;
        const progressSpacer = progressIsZero ? <img style={{ width: '0px', height: '34px' }} /> : null;
        const message = isInProgress ? (
            progressSpacer
        ) : (
            <div className={'col-xs-6'} style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                Drag files here.
            </div>
        );
        const content = uploadedFiles.length > 0 ? <div>{uploadedFiles.map(this.renderFileUpload)}</div> : message;
        return <div>{content}</div>;
    }
}

class ProgressDisplay extends React.Component {
    constructor(props) {
        super(props);
    }

    renderFileProgress = progress => {
        return progress ? (
            <div style={{ paddingTop: '7px', paddingBottom: '7px' }}>
                <ProgressBar bsStyle="success" now={progress} style={{ marginBottom: '0px' }} />
            </div>
        ) : null;
    };

    render() {
        const { progress } = this.props;
        return <div className={'col-xs-12'}> {this.renderFileProgress(progress)}</div>;
    }
}
class ErrorDisplay extends React.Component {
    // fwiw I havent seen this error displayed during dev.
    // this is not the error you receive if the file is too large
    constructor(props) {
        super(props);
    }
    renderFileError = error => {
        return error ? (
            <div>
                ERROR!! <div>{error}</div>
            </div>
        ) : null;
    };
    render() {
        const { error } = this.props;
        if (error) {
            console.log(error);
        }
        return <div>{this.renderFileError(error)}</div>;
    }
}

export default class AttachedFilesComponent extends Component {
    maxFileSize = 30 * 1000000; // 30 MB

    constructor(props) {
        super(props);
        this.invoice = null
    }

    static propType = {
        onChangeEvent: PropTypes.function,
    };
    componentDidMount() {
        this._dropZone.setState({ uploadedFiles: this.props.attachments, error: null, progress: null });
        if(this.invoice != null && this.invoice.publicUrl){
            let attachments = []
            attachments.push(this.invoice)
            this._dropZone.setState({uploadedFiles: attachments})
            this.handleDrop(this.invoice)
        }
    }
    componentWillMount(){
        if(this.props.invoiceData && this.props.invoiceData.invoiceFileData && this.props.invoiceData.invoiceFileData.fileKey){
            let attachment = {};
            let file = {};
            file.name = this.props.invoiceData.invoiceFileData.filename;
            file.type = 'application/pdf';
            attachment.file = file;
            attachment.publicUrl = `/s3/uploads/${this.props.invoiceData.invoiceFileData.fileKey}`;
            attachment.fileKey = this.props.invoiceData.invoiceFileData.fileKey;
            attachment.signedUrl = this.props.invoiceData.invoiceFileData.signedUrl;
            attachment.filename = this.props.invoiceData.invoiceFileData.fileKey;
            this.invoice = attachment
        }
    }

    handleRemove(publicUrl) {
        if (this._dropZone.state.uploadedFiles.length > 0) {
            const keptFiles = _.filter(this._dropZone.state.uploadedFiles, currentFile => {
                return currentFile.publicUrl != publicUrl;
            });
            this._dropZone.setState(
                { uploadedFiles: keptFiles, error: null, progress: null },
                this.onFinish.bind(this)
            );
            // need to call onFinish after the state change
            // the callback of onFinish isnt guaranteed to work according to the docs :(.
            // WOMM, but im open to ideas
        }
    }
    handleOnFinish(attachedFiles) {
        if (_.isFunction(this.props.onChangeEvent)) {
            this.props.onChangeEvent(attachedFiles);
        }
    }
    onFinish() {
        this.handleOnFinish(this._dropZone.state.uploadedFiles);
    }
    handleDrop = (files, rejectedFiles) => {
        const options = {
            files,
            ...this._dropZone.state.uploaderOptions,
        };
        new S3Upload(options); // eslint-disable-line
    };
    render() {
        return (
            <DropzoneS3Uploader
                className="col-xs-12"
                s3Url={`https://${config.get('APP_BUCKET')}.${config.get('AWS_REGION')}.amazonaws.com`}
                maxSize={this.maxFileSize}
                style={{
                    minHeight: '15px',
                    borderWidth: '2px',
                    borderColor: 'rgb(153, 153, 153)',
                    borderStyle: 'dashed',
                    borderRadius: '5px',
                    paddingTop: '16px',
                    paddingBottom: '16px',
                    cursor: 'pointer',
                }}
                onDropRejected={file => {
                    alert(`file attached exceeds the ${this.maxFileSize / 1000000}MB size limit.`);
                }} // this could be better
                onFinish={this.onFinish.bind(this)}
                onDrop={this.handleDrop.bind(this)}
                ref={dz => {
                    this._dropZone = dz;
                }}
                upload={{ server: window.location.origin, uploadRequestHeaders: { 'x-amz-acl': 'private' } }}
            >
                <UploadDisplay handleRemove={this.handleRemove.bind(this)} invoiceData={this.invoice}></UploadDisplay>
                <ProgressDisplay></ProgressDisplay>
                <ErrorDisplay></ErrorDisplay>
            </DropzoneS3Uploader>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/attached-files-component.js